// Where the app is running: phone or desktop, browser tab or installed app.
//
// On a phone the installed app is required; a phone browser tab only explains
// how to install. Desktop browsers are full clients and are never asked to
// install.

export type Platform = 'ios' | 'android' | 'desktop';

/** The platform from the user agent. iPadOS reports a Mac with touch. */
export function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'desktop';
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) {
    return 'ios';
  }
  if (/Android/.test(ua)) return 'android';
  return 'desktop';
}

/** Whether the app runs as an installed PWA (home-screen app). */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as { standalone?: boolean }).standalone === true
  );
}

/** A phone or tablet browser tab that has not been installed as an app. */
export function isMobileBrowser(): boolean {
  return detectPlatform() !== 'desktop' && !isStandalone();
}
